// import '@/scss/assessment.scss';
import {
  axios,
    Stream,
    Bridge,
    platform,
    toast,
    isAPP,
    APIS,
    dom,
    jumpMethods,
    Stat,
    getRequireParams
} from '@/entry/templateCommon';
import qs from 'qs';
import '@/scss/test-detail.scss';
import channelMap from '@/util/channelIdMap.config'
import {stringToObj, objToUrlParams, urlCategoryMap} from '@/lib/util';
import {AppGuide} from '@/frontend-lib/component/AppGuide/index'
import {getPlatform} from '@/util/tool';
import {getPlatform as getLibPlatform} from '@/frontend-lib/tools/getPlatform';



// const urlCategoryMap = {
//   '情感': 'qinggan',
//   '性格': 'xingge',
//   '健康': 'jiankang',
//   '职场': 'zhichang',
//   '人际': 'renji',
//   '能力': 'nengli',
//   '亲子': 'qinzi'
// }
// 题目字数控制，UI的需求
function resetTitleClass() {
    let testTitle = document.querySelector('.test-detail__title').innerText;
    if (testTitle.length > 12) {
        document.querySelector('.test-detail__title').classList.add('twoLine');
    }
}

function testBtnInit(isAPP, myTracker, requiredParams) {
    const $beginTestBtn = document.getElementById('beginTest-btn');
    // 做题按钮跳转
    if ($beginTestBtn) {
        $beginTestBtn.addEventListener('click', function (ev) {
            var authUserAddr = $beginTestBtn.getAttribute('data-jumpAddr').replace('http', 'https');

            // myTracker.startFunTest(document.querySelector('.test-detail__title').innerText);
            myTracker.send({
                name: `v5100_测评_点击开始测试`,
                properties: {
                    '测评名称': document.querySelector('.test-detail__title').innerText
                }
            });
            // alert('当前要跳转的 登录地址是： ' + authUserAddr);
            if (platform.isYixinliApp) {
                let url = new URL(authUserAddr);
                let myBridge = new Bridge();
                if (url.hash.indexOf('?') > -1) {
                    // 为什么要移除channelId，因为客户端会给URL自动注入channelId参数
                    console.log('开始移除channelId', url.href);
                    let hashQuery = stringToObj(url.hash.split('?')[1]);
                    console.log(hashQuery);
                    hashQuery.channelId = undefined;
                    url.hash = url.hash.split('?')[0] + '?' + objToUrlParams(hashQuery);
                    console.log('移除channelId结束', url.href);
                    authUserAddr = url.href + '&isCp=1'
                } else {
                    authUserAddr = authUserAddr + '?isCp=1'
                }
                myBridge.call('openWebView', {url: `${authUserAddr}`, isCurrentPageOpen: 0});
            } else {
                let urlObj = new URL(authUserAddr);
                let urlObjHashQuery = qs.parse(urlObj.hash.split('?')[1] ? urlObj.hash.split('?')[1] : '');

                if (urlObjHashQuery.channelId * 1 === 0) {
                    urlObjHashQuery.channelId = requiredParams.channelId;
                }
                urlObj.hash = `${urlObj.hash.split('?')[0]}?${qs.stringify(urlObjHashQuery)}`
                console.log(urlObj);
                console.log(urlObj.href);
                window.location.href = urlObj.href;
            }
        });
    }
}

function getRecomend({channelId, userKey, scalePoolId}, myTracker, requiredParams) {
    return new Promise((resolve,reject) => {
      const postResolve = resolve
      function getItemCategoryUrl(item) {
        return urlCategoryMap(item.category)
      }
      const stringFactory = function (data) {
          return `<li class="assessment-list__item" data-id="${data.scalePoolId}">
                          <div class="cf">
                              <div class="fl assessment-list__item__left">
                                  <a class="assessment-list__item-title color-main text-limit fs-16">${data.name}</a>
                                  <div class="assessment-list__item-desc color-light text-limit fs-12">${data.shortDescribe}</div>
                              </div>
                              <div class="fr">
                                  <img src="${data.listPicture}" alt="" class="assessment-list__item-img"></div>
                              </div>
                              <div class="assessment-list__item-footer cf fs-12">
                                <div class="color-red  assessment-list-price">${data.discountPrice}元</div>
                                  <div class="fl assessment-list__item-category" id="itemCategory" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceshi/${getItemCategoryUrl(data)}">
                                    ${data.category + '-' + data.categoryTags.split(',')[0]}
                                  </div>
                                  <div class="color-light fr">${data.countDesc}</div>
                              </div>
                          </li>`;
      }

      const recomendBlock = function (category) {
          const categoryUrl = urlCategoryMap(category)
          let div = document.createElement('div');
          div.innerHTML = `<section class="bg-fff pb20">
              <h2 class="common-section-title fs-16">热门心理测试推荐</h2>
              <ol class="assessment-list"  id="recomemdList">
              </ol>
              <div class="toSort"><a href="https://m${APIS.env}.xinli001.com/ceshi/${categoryUrl}">查看更多测评</a></div>
          </section>`
          return div;
      }

      Stream.ajax('/qu/fun/getFunRecommends', {
          channelId: channelId,
          userKey,
          id: scalePoolId,
          from: 'detail'
      }).addListener({
          next(json) {
              const {code, msg, data} = json;
              if (+code === 1) {
                  if (data.lists && data.lists.length > 0) {
                      let recomendEle = recomendBlock(data.lists[0].category)
                      recomendEle.querySelector('#recomemdList').innerHTML = data.lists.map(stringFactory).join('');
                      document.querySelector('.test-detail-article-page').appendChild(recomendEle);
                      recomendEle.addEventListener('click', (e) => {
                          let liEle = dom.closest(e.target, 'li');

                          if (e.target.id == 'itemCategory') {
                            let outerText = e.target.outerText.split('-')[0]
                            jumpMethods.goToSortPage(Object.assign({}, {
                              category: urlCategoryMap(outerText)
                            }));
                            return
                          }

                          if (liEle) {
                              // myTracker.funDetailRecomend(liEle.querySelector('.assessment-list__item-title').innerText);
                              myTracker.send({
                                  name: `v5100_测评_点击大家都在测-测试详情页`,
                                  properties: {
                                      '测评名称': liEle.querySelector('.assessment-list__item-title').innerText
                                  }
                              });
                              jumpMethods.goToProTestPage(Object.assign(requiredParams, {
                                  scaleId: liEle.getAttribute('data-id')
                              }));
                          }
                      });
                      postResolve()
                  }

              }
          }
      })
    })

}

function getComment(requiredParams) {
  const commentLi = item => {
    let li = document.createElement('li');
    li.innerHTML = `
      <li>
        <div class="comment-list__item box-padding">
          <div class="flex flex--middle fs-12 comment-list__item-meta">
            <div class="flex flex--middle flex__item--big">
              <img src="${item.avatar}" class="comment-list__item-pic flex__item--small">
              <span class="comment-list__item-name flex__item--big text-overflow">${item.nickname}</span>
            </div>
          </div>
          <p class="comment-list__item-content color-black">${item.commentContent}</p>
        </div>
      </li>
    `
    return li
  }
  axios.get(`${APIS.lingxiHost}newestFunEvaluation`, {
    params: {
      page: 1,
      pageSize: 3,
      appCode: 1,
      funScaleId: requiredParams.scalePoolId
    }
  }).then(res => {
    if (res.data.code === '1') {
      const lists = res.data.data.lists || []
      lists.forEach(item => {
        document.querySelector('#comment').appendChild(commentLi(item))
      })
    }
  })
  document.querySelector('.view-more-comment').addEventListener('click', () => {
    let url = `https://ce${APIS.env}.xinli001.com/cp-m/index.html#/assessment/fun/${requiredParams.scalePoolId}/comment?${objToUrlParams(Object.assign({}, requiredParams, {isCp: 1}))}`;
    setTimeout(() => {
      jumpMethods.openUrl(url);
    }, 200)
  })
}

function initWantTest(requiredParams, myTracker, testName) {
  const {userKey, userId, scalePoolId} = requiredParams;
  const detailUrl = location.href;
  const $likeBtn = document.getElementById('like-btn');
  const $likeClassList = $likeBtn.querySelector('i').classList;
  let redirectUrl = '';
  if (platform.isPc) {
    redirectUrl = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
  }
  Stream.fromEvent($likeBtn, 'click')
    .do(() => {
      if (!userKey && !userId) {
        if (platform.isPc) {
          location.href = `https://account${APIS.env}.xinli001.com/login?next=${encodeURIComponent(detailUrl)}`;
          console.log(location.href);
        }
      }
    })
    .map(() => $likeClassList.contains('icon-like-active'))
    .flattenMap(like => Stream.ajax('/api/favor/favorScale', Object.assign(requiredParams, {
      scalePoolId,
      status: !like,
      userKey,
      id: $likeBtn.getAttribute('data-favor'),
      redirectUrl: redirectUrl, // 添加此参数，后端返回前端302的时候，就会不使用后端返回的地址，使用这个参数指定的地址
      testType: 1, // 趣味测评
    }), false)
      .pardonError(err => {
        console.error(err);
      }))
    .flattenMap(like => Stream.of(like))
    .addListener({
      next(res) {
        const {code, data} = res;
        if (+code === 1) {
          if (data.status === false) {
            $likeBtn.classList.remove('like-active')
            $likeClassList.remove('icon-like-active');
            $likeClassList.add('icon-like');
          } else {
            $likeBtn.setAttribute('data-favor', res.data.id);
            $likeBtn.classList.add('like-active');
            $likeClassList.remove('icon-like');
            $likeClassList.add('icon-like-active');
            toast('收藏成功！可在“测试管理--想测”查看该内容');
          }
        }
        myTracker.send({
          name: `测评-趣味测试-交互行为`,
          properties: {
            '对象': '点击“想测”按钮',
            '页面': '测评详情页',
            '测评名称': testName
          }
        });
      }
    });
}

function initWelfare(myTracker, testName) {
  const $welfareBtn = document.getElementById('service-btn')
  const $redpacketPopup = document.querySelector('.welfare__popup')
  const $redpacketBefore = document.querySelector('.welfare__before-content')
  const $redpacketIng = document.querySelector('.welfare__ing-content')
  const $redpacketAfter = document.querySelector('.welfare__after-content')
  $redpacketBefore.style.display = 'none'
  $welfareBtn.addEventListener('click', () => {
    $redpacketPopup.style.display = 'flex'
    $redpacketIng.style.display = 'flex'
    myTracker.send({
      name: `测评-趣味测试-交互行为`,
      properties: {
        '对象': '点击“福利”按钮',
        '页面': '测评详情页',
        '测评名称': testName
      }
    });
  })
  $redpacketPopup.addEventListener('click', () => {
    $redpacketPopup.style.display = 'none'
    // $redpacketBefore.style.display = 'none'
    $redpacketIng.style.display = 'none'
    $redpacketAfter.style.display = 'none'
  })
  // $redpacketBefore.addEventListener('click', (e) => {
  //   e.stopPropagation()
  //   $redpacketIng.style.display = 'flex'
  // })
  $redpacketIng.addEventListener('click', (e) => {
    e.stopPropagation()
    $redpacketIng.style.display = 'none'
    $redpacketAfter.style.display = 'flex'
  })
  $redpacketAfter.addEventListener('click', (e) => {
    e.stopPropagation()
    $redpacketPopup.style.display = 'none'
    $redpacketAfter.style.display = 'none'
  })
}

function getReviewbox() {
   var loopData = document.getElementById("testDepressionLoop");
   loopData.style = `animation-duration: ${5 + loopData.children.length*3}s`
}

function initDownguide(myTracker) {
    console.log('--- 初始化下载 ---')
    console.log('--- AppGuide ---', AppGuide)
    let customClass
    if (getPlatform().isPc) customClass = `isPC`
    if (getLibPlatform().isBaiduminiapp) customClass = 'isBaiduminiapp'
    AppGuide.init({text: '.', customClass: customClass})
    const $el = document.querySelector('#AppGuide')
    if ($el) {
        $el.addEventListener('click', () => {
            myTracker.send({
                name: '公共-App导流',
                properties: {
                    '来源': '趣味测试详情页-下载App'
                }
            })
            AppGuide.download('quweixq',false)
        })
    }
}

function linkGoinit(isAPP, myTracker, requiredParams){
 let linkEle = document.createElement('div');
 linkEle.innerHTML =  `<div class="bg-fff content-block" style="overflow: hidden;margin-top:10px;">
    <div class="yixinlitest-link-title fs-16 common-section-title">友情链接</div>
    <ul class="yixinlitest-link-list fs-14 flex" id="yixinlitestLink">
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="http://static${APIS.env}.xinli001.com/cp-m/index.html#/index">进入测评大厅</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="http://static${APIS.env}.xinli001.com/cp-m/index.html#/index">专业心理测试</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/782">抑郁心理测试</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/353">抑郁了怎么办</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/819">失眠了怎么办</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/443">如何走出自卑</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/75">职业性格测试</li>
        <li class="yixinlitest-link-one fs-12" data-jumpAddr="https://m${APIS.env}.xinli001.com/ceping/603">人格测试</li>
    </ul>
  </div>`
  document.querySelector('.test-detail-article-page').appendChild(linkEle);

  let linkListEle = document.getElementById('yixinlitestLink')
  linkListEle.addEventListener('click', (e) => {
      let liEle = dom.closest(e.target, 'li');
      var liEleUrl = liEle.getAttribute('data-jumpAddr')
      jumpMethods.openUrl(liEleUrl)
  });
}

function getCategoryTap(){
  const $thiscategory = document.querySelector('.test-detail__category')
  const thiscategoryText = document.querySelector('.test-detail__category').firstElementChild.innerText.slice(0,2)
  var categoryUrl = `https://m${APIS.env}.xinli001.com/ceshi/${urlCategoryMap(thiscategoryText)}`
  $thiscategory.addEventListener('click', function (ev) {
      if (platform.isYixinliApp) {
          let url = new URL(categoryUrl);
          let myBridge = new Bridge();
          if (url.hash.indexOf('?') > -1) {
              let hashQuery = stringToObj(url.hash.split('?')[1]);
              hashQuery.channelId = undefined;
              url.hash = url.hash.split('?')[0] + '?' + objToUrlParams(hashQuery);
              categoryUrl = url.href + '&isCp=1'
          } else {
              categoryUrl = categoryUrl + '?isCp=1'
          }
          myBridge.call('openWebView', {url: `${categoryUrl}`, isCurrentPageOpen: 0});
      } else {
          let urlObj = new URL(categoryUrl);
          window.location.href = urlObj.href;
      }
  });
}

function hideWantBtn(requiredParams) {
  let endTime = new Date('2023/05/31 23:59:59').getTime()
  console.log('=== hideWantBtn === endTime:', endTime)

  if (Date.now() < endTime && +requiredParams.channelId == 513) {
    const serviceBtn = document.getElementById('service-btn')
    const verticalBar = document.querySelector('.art-handler .vertical-bar')
    serviceBtn.style.display = 'none'
    verticalBar.style.display = 'none'
  }
}

window.onload = async function () {
    try {
        let pathArray = location.pathname.split('/');
        let scalePoolId = pathArray[pathArray.length - 1];
        if (location.pathname[location.pathname.length - 1] == '/') {
           scalePoolId = pathArray[pathArray.length - 2];
        }
        let requiredParams = await getRequireParams();

        let myTracker = new Stat({
            globalParams: {
                '渠道ID': requiredParams.channelId*1,
                '渠道': channelMap.map[requiredParams.channelId * 1],
            }
        });
        let testName = document.querySelector('.test-detail__title').innerText;

        console.log('---趣味详情页众参数---')
        console.log(requiredParams)
        window.sharePageName = '测试详情页';
        window.sharePagOption = {
            '测试名称': testName
        };

        // myTracker.pageView('测试详情页', {
        //     '测试名称': testName
        // })

        myTracker.send({
            name: `v5100_测评_访问测试详情页`,
            properties: {
                '测评名称': testName
            }
        });
        resetTitleClass();
        testBtnInit(isAPP, myTracker, requiredParams);
        // initDownguide(myTracker)
        // 已经获取了requiredParams，不用再分情况了
        getRecomend(Object.assign({}, requiredParams, {scalePoolId}), myTracker, requiredParams).then(() => {
          // 非app环境下才出友情链接
          if(!platform.isYixinliApp){
            linkGoinit(isAPP, myTracker, requiredParams)
          }

        })

        // 获取评论
        getComment(Object.assign({}, requiredParams, {scalePoolId}))

        // 福利按钮事件
        initWelfare(myTracker, testName)

        // 购买轮播
        getReviewbox()

        // 初始化标签跳转
        getCategoryTap()

        // 想测按钮事件
        initWantTest(Object.assign({}, requiredParams, {scalePoolId}), myTracker, testName)

        // m 站隐藏一段时间红包入口
        hideWantBtn(requiredParams)

    } catch (err) {
        console.log(err);
    }
}



// WEBPACK FOOTER //
// ./src/entry/testDetail/index.js